import { documentEventTypeDocumentIsShow, getI18nT, Log } from "@fanfanlo";
import { androidDispatchers } from "../androidDispatchers";
import { AutoWebViewJs } from "../AutoWebViewJs";
import { WebViewJs } from "../WebViewJs";
import { getTrans } from "./i18n";
import { Manifest } from "./Manifest";
import { Permission } from "./Permission";
import { PermissionAskUi } from "./PermissionAskUi";
import { PermissionAskUiConf, PermissionConf } from "./PermissionInterfaces";

// console.trace('float permission')
let trans:any
async function floatpermissionInit(){
    trans = await getI18nT("droid-android/android/components/content")
}
floatpermissionInit()
function callback(isOk:boolean, rejectMsg:string):void{

}

function createAskScript(eventType:string, id:string){
    let script = `
var bl = com.fanfanlo.lib.permissions.FloatPermission.openPermission(function(bl){
        webViewJs.callJsEvent("${eventType}", bl, "${id}");
    });
    webViewJs.callJsEvent("${eventType}", bl, "${id}");
`
    const conf = {
        forceStopTime:0,
        onlyRunSingle :true,
        stopPrevIfOnlyRunSingle: true,
        injects:[["webViewJs"]],
        script
    }
    return AutoWebViewJs.confToScript(conf);
}
function createPermissionConf(askUi:PermissionAskUi, eventType:string, id:string){

    let conf:PermissionConf = {
        askUi: askUi, callback,  permissionId: 0,
        scripts: {
            ask: {
                script:createAskScript(eventType, id),
                isRunner:true
            },
            check: {
                script:`var bl = com.fanfanlo.lib.permissions.FloatPermission.hasPermission();\n bl;`,
                isRunner:false
            }
        },
        listenResume:false
    }
    return conf
}

function createAskUi(){
    const t = getTrans()
    let conf:PermissionAskUiConf = {
        cancelButtonText: t("floatPermission.cancel"),
        checkBoxText: t("floatPermission.checkBoxText"),
        hasCheckBox: true,
        okButtonText: t("floatPermission.ok"),
        // storageKey: storageKeys.permissions.float.showAsk,
        storageKey: 'storageKeys.permissions.float.showAsk',
        text: t("floatPermission.content"),
        title:t("floatPermission.title")
    }
    let askUi = new PermissionAskUi();
    askUi.conf = conf;
    return askUi
}

function listenAskBackEvent(eventType:string, permission:Permission){
    let print = new Log(false, "fn-listenAskBackEvent").print;

    const index = WebViewJs.instance.shellListen(androidDispatchers.webViewJs.name, eventType, eventType, true, onBack);
    print("index is", index);
    function onBack(data:any){
        print("fn-onBack result is", data)
    }
    document.addEventListener(documentEventTypeDocumentIsShow, onDocumentShow)
    function onDocumentShow(){
        document.removeEventListener(documentEventTypeDocumentIsShow, onDocumentShow)
        let res = WebViewJs.instance.shellRemoveListen(androidDispatchers.webViewJs.name, index);
        permission.askComplete();
        print("android listener removeListen", res);
    }

}
export function createFloatPermission(){
    let askUi = createAskUi();
    let id = Date.now().toString()
    let eventType = `onFloatPermissionSettingResult${id}`
    let permissionConf = createPermissionConf(askUi, eventType, id)
    let floatPermission = new FloatPermission();
    floatPermission.conf = permissionConf;

    return floatPermission;
}

class FloatPermission extends Permission{
    constructor() {
        super();
        this.androidPermissionList = [
            Manifest.Permission.SYSTEM_ALERT_WINDOW
        ]
    }
    ask(){
        let id = Date.now().toString()
        let eventType = `onFloatPermissionSettingResult${id}`
        this.conf.scripts.ask.script = createAskScript(eventType, id);
        listenAskBackEvent(eventType, this);
        let res = super.ask();
        this.dispatchMayUpdatedEvent(undefined, undefined)
    }
}
